'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _setTimeout = require('common/utils/set-timeout');

var _setTimeout2 = _interopRequireDefault(_setTimeout);

var _tooltip = require('common/components/tooltip');

var _tooltip2 = _interopRequireDefault(_tooltip);

var _removeEnterpriseMember = require('./remove-enterprise-member');

var _removeEnterpriseMember2 = _interopRequireDefault(_removeEnterpriseMember);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var TeamMember = _react2['default'].createClass({
    displayName: 'TeamMember',


    /**
     */

    propTypes: {
        'member': _react2['default'].PropTypes.object.isRequired
    },

    /**
     */

    getInitialState: function getInitialState() {
        return {};
    },


    /**
     */

    setMemberRole: function setMemberRole(code, event) {

        if (this.props.member.isLoggedInUser() && this.props.member.canModifyTeam() && !confirm('Are you sure you want to revoke your Admin privileges? You will no longer be able to modify your team.')) {
            return;
        }

        this.props.member.promote(code);
        event.preventDefault();
        event.stopPropagation();
    },


    /**
     */

    resetPassword: function resetPassword(event) {

        event.preventDefault();
        if (!confirm('Are you sure you want to reset the password for this account?')) {
            return;
        }

        this.props.member.resetPassword();
    },


    /**
     */

    unlockMember: function unlockMember(event) {

        event.preventDefault();
        this.props.member.unlock();
    },


    /**
     */

    lockMember: function lockMember(event) {

        event.preventDefault();
        if (!confirm('Are you sure you want to lock this account?')) {
            return;
        }

        this.props.member.lock();
    },


    /**
     */

    removeMember: function removeMember(event) {

        event.preventDefault();

        var removeText = 'Are you sure you want to remove this user from your team? Note: this user\'s account will still exist. However, they will no longer be';
        removeText += this.props.member.pending ? ' invited to join your team.' : ' part of your team.';
        if (_hfReactHelper2['default'].isHelloSign() && !this.props.member.pending) {
            removeText += ' IMPORTANT: Any templates this user created will be transferred to you and their signatures will be removed from them.';
        }

        if (!confirm(removeText)) {
            return;
        }

        this.props.member.remove();
    },


    /**
     */

    removeEnterpriseMember: function removeEnterpriseMember(event) {

        event.preventDefault();

        this.props.app.actions.ui.showModal(_react2['default'].createElement(_removeEnterpriseMember2['default'], this.props), { 'showCloseButton': false }, 'remove-enterprise-member');
    },


    /**
     */

    toggleMenu: function toggleMenu(show) {
        clearTimeout(this._hideTimeout);

        // TODO: clean me - hack to prevent menu from hiding too quickly - this
        // needs to be placed within a menu component (CC)
        var self = this;
        if (show) {
            this.setState({ 'showMenu': show });
        } else {
            this._hideTimeout = (0, _setTimeout2['default'])(function () {
                self.setState({ 'showMenu': show });
            }, 100);
        }
    },


    /**
     */

    showTemplates: function showTemplates() {

        // TODO: reactify this component - here to support legacy stuff
        // for now
        var a = document.createElement('a');
        var guid = this.props.member.guid || this.props.member.uid;
        a.setAttribute('href', '/home/viewTemplatePermissionsForAccount?guid=' + guid);

        $(a).fancybox({
            'showCloseButton': false,
            'type': 'iframe',
            'height': 375,
            'width': 500
        }).click();
    },


    /**
     */

    toggleCloseButton: function toggleCloseButton(show) {
        this.setState({
            'showClose': show
        });
    },


    /**
    * Returns true for Admins (owners) and Developers
    */
    shouldShowActionMenu: function shouldShowActionMenu() {
        return this.props.teamMembers && this.props.teamMembers.loggedInUserCanModifyTeam();
    },


    /**
    *
    */
    userIsAdmin: function userIsAdmin() {
        return this.props.teamMembers && this.props.teamMembers.loggedInUserIsAdmin();
    },


    /**
     */

    isEnterprise: function isEnterprise() {
        return this.props.app.user.getTeam().isEnterprise();
    },


    /**
     */

    isHighPayingEnterprise: function isHighPayingEnterprise() {
        return this.props.app.user.getTeam().isHighMrrEnterprise;
    },


    /**
     */

    isTransferDocsAdmin: function isTransferDocsAdmin() {
        return this.props.app.user.getTeam().isTransferDocsAdmin;
    },


    /**
     */

    hasTransferDocsAdmin: function hasTransferDocsAdmin() {
        return this.props.app.user.getTeam().hasTransferDocsAdmin;
    },


    /**
     */

    isRemovable: function isRemovable() {
        var isAdmin = this.userIsAdmin();
        var isEnterprise = this.isEnterprise();
        var isLoggedInUser = this.props.member.isLoggedInUser();

        return isAdmin && !(isEnterprise && isLoggedInUser);
    },
    getNumUnlockedAdmins: function getNumUnlockedAdmins() {
        var count = 0;
        var members = this.props.teamMembers;
        for (var i = 0; i < members.length; i++) {
            if (members.at(i).isAdmin() && !members.at(i).isLocked) {
                count++;
            }
        }
        return count;
    },


    /**
     */

    render: function render() {
        var member = this.props.member;
        var loggedInUser = this.props.teamMembers.getLoggedInUser();
        var isSoleUnlockedAdmin = typeof loggedInUser != 'undefined' && member.emailAddress === loggedInUser.emailAddress && this.getNumUnlockedAdmins() < 2;

        var classNames = (0, _classnames2['default'])({
            'team_member': true,
            'show': this.state.showMenu
        });

        var sections = {};

        // Templates
        if (_hfReactHelper2['default'].isHelloSign() && !member.isLocked) {
            sections.templateMenuItem = _react2['default'].createElement(
                'li',
                { key: 'menu', className: 'menuLink template_access' },
                _react2['default'].createElement(
                    'a',
                    { href: '#', className: 'show_template_access_link', onClick: this.showTemplates },
                    _react2['default'].createElement('b', { className: 'ico' }),
                    'Templates'
                )
            );
        }

        // User administration functions only available to Admins, not Devs
        if (this.userIsAdmin()) {
            // Make Admin
            if (!member.isAdmin() && !member.isLocked) {
                sections.adminMenuItem = _react2['default'].createElement(
                    'li',
                    { key: 'make-admin', className: 'menuLink make-admin' },
                    _react2['default'].createElement(
                        'a',
                        { href: '#', onClick: this.setMemberRole.bind(this, 'a') },
                        _react2['default'].createElement('b', { className: 'ico' }),
                        'Make Admin'
                    )
                );
            }

            // Make Developer
            if (!member.isDeveloper() && !member.isLocked && !isSoleUnlockedAdmin) {
                sections.devMenuItem = _react2['default'].createElement(
                    'li',
                    { key: 'make-developer', className: 'menuLink make-developer' },
                    _react2['default'].createElement(
                        'a',
                        { href: '#', onClick: this.setMemberRole.bind(this, 'd') },
                        _react2['default'].createElement('b', { className: 'ico' }),
                        'Make Developer'
                    )
                );
            }

            // Make Member
            if (!member.isMember() && !member.isLocked && !isSoleUnlockedAdmin) {
                sections.memberMenuItem = _react2['default'].createElement(
                    'li',
                    { key: 'make-member', className: 'menuLink make-member' },
                    _react2['default'].createElement(
                        'a',
                        { href: '#', onClick: this.setMemberRole.bind(this, 'm'), style: { 'fontSize': '10px' } },
                        _react2['default'].createElement('b', { className: 'ico' }),
                        'Make Member'
                    )
                );
            }

            // high paying enterprise options
            if (this.isHighPayingEnterprise() && !member.isLocked && !this.props.member.isLoggedInUser()) {
                // Lock Account
                sections.lockMenuItem = _react2['default'].createElement(
                    'li',
                    { className: 'menuLink' },
                    _react2['default'].createElement(
                        'a',
                        { href: '#', className: 'lock_team_member', onClick: this.lockMember },
                        _react2['default'].createElement('b', { className: 'ico' }),
                        'Lock Account'
                    )
                );

                // Reset Password
                sections.resetPasswordMenuItem = _react2['default'].createElement(
                    'li',
                    { className: 'menuLink' },
                    _react2['default'].createElement(
                        'a',
                        { href: '#', className: 'reset_password_team_member', onClick: this.resetPassword },
                        _react2['default'].createElement('b', { className: 'ico' }),
                        'Reset Password'
                    )
                );
            }
        }

        // Unlock Account
        if (member.isLocked) {
            sections.unlockMenuItem = _react2['default'].createElement(
                'li',
                { className: 'menuLink' },
                _react2['default'].createElement(
                    'a',
                    { href: '#', className: 'unlock_team_member', onClick: this.unlockMember },
                    _react2['default'].createElement('b', { className: 'ico' }),
                    'Unlock Account'
                )
            );
        }

        // Remove
        if (this.isRemovable()) {
            var removeHandler = this.isEnterprise() && this.isTransferDocsAdmin() ? this.removeEnterpriseMember : this.removeMember;
            sections.removeMenuItem = _react2['default'].createElement(
                'li',
                { className: 'menuLink' },
                _react2['default'].createElement(
                    'a',
                    { href: '#', className: 'remove_team_member', onClick: removeHandler },
                    _react2['default'].createElement('b', { className: 'ico' }),
                    'Remove'
                )
            );
        }

        if (member.pending) {

            var closClassNames = (0, _classnames2['default'])({
                'action_col': true,
                'show': this.state.showClose
            });

            // TODO - move to scss file when scss is organized (CC)
            sections.actionsColumn = _react2['default'].createElement(
                'td',
                { className: closClassNames, onMouseOver: this.toggleCloseButton.bind(this, true), onMouseOut: this.toggleCloseButton.bind(this, false) },
                _react2['default'].createElement('img', { src: require('./team_x_icon@2x.png'), onClick: this.removeMember, title: 'Remove', alt: 'Remove', className: 'delete_team_invite_link' })
            );
        } else {
            sections.actionsColumn = _react2['default'].createElement(
                'td',
                { className: 'action_col', style: { opacity: 1 } },
                this.shouldShowActionMenu() ? _react2['default'].createElement(
                    'div',
                    { className: 'arrow', onMouseOver: this.toggleMenu.bind(this, true), onMouseOut: this.toggleMenu.bind(this, false) },
                    _react2['default'].createElement(
                        'ul',
                        null,
                        sections.templateMenuItem,
                        sections.adminMenuItem,
                        sections.devMenuItem,
                        sections.memberMenuItem,
                        sections.resetPasswordMenuItem,
                        sections.lockMenuItem,
                        sections.unlockMenuItem,
                        sections.removeMenuItem
                    )
                ) : void 0
            );
        }

        // TODO - don't do this - need to use CSS ellipsis instead
        var emailAddress = member.emailAddress.toLowerCase();
        if (emailAddress.length > 30) {
            emailAddress = emailAddress.substring(0, 27) + '...';
        }

        var role_label;
        if (member.pending) {
            role_label = member.pending_email_confirmation ? "(Pending)" : "(Invited)";
        } else {
            role_label = member.getRoleTypeLabel();
        }

        var lockId = 'lock_' + this.props.member.guid;
        var lockedIcon = _react2['default'].createElement('img', { id: lockId, className: 'team-page-lock', src: require('./lock.png') });
        var tooltip = _react2['default'].createElement(_tooltip2['default'], {
            content: 'This user is currently locked',
            lockToElement: '#' + lockId,
            arrowPosition: 'left'
        });
        var emailStyle = member.isLocked ? { position: 'relative', top: '-2px' } : {};
        return _react2['default'].createElement(
            'tr',
            { className: classNames, style: { display: 'table-row' } },
            _react2['default'].createElement(
                'td',
                { className: 'email_col' },
                _react2['default'].createElement(
                    'span',
                    { style: emailStyle },
                    member.emailAddress
                ),
                member.isLocked ? lockedIcon : void 0,
                member.isLocked ? tooltip : void 0
            ),
            _react2['default'].createElement(
                'td',
                { className: 'role_col' },
                role_label
            ),
            _hfReactHelper2['default'].isHelloSign() ? _react2['default'].createElement(
                'td',
                { className: 'templates_col' },
                member.numTemplates
            ) : void 0,
            sections.actionsColumn
        );
    }
});

module.exports = TeamMember;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/app/content/team/member.jsx
 ** module id = 847
 ** module chunks = 0
 **/